const SUPER_EXPERT_IDS = [7, 1843]

export const isSuperExpert = (userId?: number | string | null): boolean => SUPER_EXPERT_IDS.includes(Number(userId))
